<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import SalesReviewPartyCard from './SalesReviewPartyCard.vue';

defineProps({
  companies: { type: Array, default: () => [] },
  countLabel: { type: String, required: true },
  people: { type: Array, default: () => [] },
  title: { type: String, required: true },
});
const emit = defineEmits(['open']);
const { t } = useI18n();
const expanded = ref(true);
</script>

<template>
  <section
    data-review-party-section
    class="grid gap-6 rounded-lais border border-lais-border-soft bg-white p-4 shadow-lais-soft sm:p-6"
  >
    <header class="flex items-center justify-between gap-4">
      <div class="flex min-w-0 flex-wrap items-center gap-3">
        <h2 class="font-redHatDisplay text-xl font-bold text-lais-text">
          {{ title }}
        </h2>
        <span
          class="rounded-full bg-lais-bg-soft px-3 py-1 text-xs font-bold text-lais-text-muted"
        >
          {{ countLabel }}
        </span>
      </div>
      <button
        type="button"
        class="grid size-9 place-items-center rounded-lais-sm text-lais-primary hover:bg-lais-bg-soft"
        :aria-label="t('SALES.REVIEW.RETURN_FORM.TOGGLE')"
        @click="expanded = !expanded"
      >
        <span
          class="size-5"
          :class="expanded ? 'i-lucide-chevron-up' : 'i-lucide-chevron-down'"
          aria-hidden="true"
        />
      </button>
    </header>

    <div v-if="expanded" class="grid gap-6">
      <div
        v-if="people.length"
        class="grid gap-5 sm:grid-cols-2 xl:grid-cols-4"
      >
        <SalesReviewPartyCard
          v-for="card in people"
          :key="card.party.id"
          :card="card"
          @open="emit('open', $event)"
        />
      </div>

      <div
        v-for="company in companies"
        :key="company.company.id"
        class="grid gap-5 rounded-lais bg-lais-bg-soft p-4 sm:p-6"
      >
        <div class="flex flex-wrap items-center justify-between gap-2">
          <p class="text-sm font-bold text-lais-text">
            {{ company.company.name }}
          </p>
          <span class="text-xs font-semibold uppercase text-lais-text-muted">
            {{ t('SALES.REVIEW.PARTIES.COMPANY') }}
          </span>
        </div>
        <div class="grid gap-5 sm:grid-cols-2 xl:grid-cols-4">
          <SalesReviewPartyCard
            v-if="company.card"
            :card="company.card"
            @open="emit('open', $event)"
          />
          <SalesReviewPartyCard
            v-for="card in company.representatives"
            :key="card.party.id"
            :card="card"
            @open="emit('open', $event)"
          />
        </div>
      </div>

      <p
        v-if="!people.length && !companies.length"
        class="rounded-lais-sm bg-lais-bg-soft p-4 text-sm text-lais-text-muted"
      >
        {{ t('SALES.REVIEW.PARTIES.EMPTY') }}
      </p>
    </div>
  </section>
</template>
